import { SET_CUSTOMIZER_STATE, UPDATE_CUSTOMIZER_SECTOR } from './chunk-LCTYHW34.mjs';

// src/state/register/customizer/reducer.ts
var CUSTOMIZER_INITIAL_STATE = {
  topLeft: true,
  topRight: true,
  bottomLeft: true,
  bottomRight: true
};
var customizerReducer = (state = CUSTOMIZER_INITIAL_STATE, { payload, type }) => {
  if (type === SET_CUSTOMIZER_STATE)
    return payload;
  if (type === UPDATE_CUSTOMIZER_SECTOR)
    switch (payload) {
      case "whole":
        return {
          topLeft: true,
          topRight: true,
          bottomLeft: true,
          bottomRight: true
        };
      case "leftHalf":
        return {
          topLeft: true,
          bottomLeft: true,
          topRight: false,
          bottomRight: false
        };
      case "rightHalf":
        return {
          topRight: true,
          bottomRight: true,
          topLeft: false,
          bottomLeft: false
        };
      default:
        return {
          topLeft: false,
          topRight: false,
          bottomLeft: false,
          bottomRight: false,
          [payload]: true
        };
    }
  return state;
};
var reducer_default = customizerReducer;

export { CUSTOMIZER_INITIAL_STATE, reducer_default };
